// extracted by mini-css-extract-plugin
module.exports = {"switchSelect":"styles_switchSelect__LoISY","switchSelect__switchContainer":"styles_switchSelect__switchContainer__1VkcI","readOnly":"styles_readOnly__PI62b"};